export enum ContainerModelState {
	OPEN = 'OPEN',
	DECAY = 'DECAY',
	RELEASE_DATE_REACHED = 'RELEASE_DATE_REACHED',
	DISPATCHED = 'DISPATCHED',
	DISPOSED = 'DISPOSED'
}
